// extracted by mini-css-extract-plugin
module.exports = {"answers":"questionFour_answers__10FGK","buttonEmoji":"questionFour_buttonEmoji__1bvjY","quizButton":"questionFour_quizButton__2B_7S","active":"questionFour_active__j5Z6s"};